import type { App } from 'vue';
import { createPinia } from "pinia";
import { pluginTasksStore } from "@/store/tasksStore";
import configStore from "@nextories/vue-core-components/src/utils/helpers/configStore";
import {pluginRootStore} from "@/store/rootStore";
import {useSavStore} from "@/store/savStore";
import {useFurnitureStorage} from "@/store/furnitureStorageStore";

// Create and export Pinia
export const pinia = createPinia();

export default {
  pluginStore: {
    tasks: pluginTasksStore,
    root: pluginRootStore,
  },
  install(app: App) {
    // Set state and actions in store pinia
    // tasks
    pinia.use(({ store }) => {
      if (store) {
        const plugin = this.pluginStore[store.$id];
        if (plugin) {
          const otherState = store.$id === "root"
            ? {
              sav: JSON.parse(JSON.stringify(useSavStore().$state)),
              furnitureStorage: JSON.parse(JSON.stringify(useFurnitureStorage().$state)),
            } : undefined;
          configStore.updateStoreStateAndActions(
            store,
            plugin,
            otherState,
          );
        }
      }
    });
    app.use(pinia);
  },
};
